(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    window.setTimeout(function(){
  var $swatch_wrappers = $('.grid-product__colors');
  $swatch_wrappers.each(function(index){

                var $swatch_wrapper = $(this);
                console.log( $(this).attr("class") );
                $swatch_wrapper.show().find('.color-swatch').sort(function(a, b) {
                    return +a.getAttribute('sort') - +b.getAttribute('sort');
                }).appendTo( $swatch_wrapper );
                var swatch_count = $swatch_wrapper.find('.color-swatch').size();
                var swatch_limit = 4
                if( swatch_count > swatch_limit ) {
                  $swatch_wrapper.append($('<span></span>').hide().addClass("additional-swatches"));
                  var $additional_swatches = $swatch_wrapper.find('.additional-swatches');
                  $swatch_wrapper.find('.color-swatch').each(function(index){
                    if( index < 4 ) {
                      $(this).appendTo( $swatch_wrapper );
                    }else{
                      $(this).appendTo( $additional_swatches );
                    }
                  });
                  $additional_swatches.appendTo( $swatch_wrapper );
                  $swatch_wrapper.append(
                    $('<span> + ' + (swatch_count - swatch_limit) + '</span>')
                    .addClass("show-additional-swatches")
                    .css('left','2px')
                    .bind('click', function(){
                      document.querySelectorAll('.additional-swatches').forEach(f => {
                          f.style.display = 'none';
                      });
                      document.querySelectorAll('.show-additional-swatches').forEach(g => {
                          g.style.display = 'inline';
                      });
                      this.style.display = 'none';
                      this.parentElement.querySelector('.additional-swatches').style.display='inline';
                    })
                  );
                }

  });
},5000);
  } catch(e) { console.error(e); }
})();

})();
